import SelectFilterStep, {
  CATEGORY_FILTER_DRAWER_ALLOWED_FILTERS,
} from '@app/src/components/CreateNewRequestModal/Common/SelectFilterStep'
import { useCreationModalProgress } from '@app/src/context/CreationModalProgressContext'
import { useGetApiQueryFilters } from '@app/src/hooks/queryFilters'
import { useFiltersContext } from '@app/src/pages/ResourceCollection/Filters/Filters'
import { FormControlLabel, Radio, RadioGroup } from '@mui/material'
import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'
import useDeepCompareEffect from 'use-deep-compare-effect'
import { GOAL_TRACKER_QUESTION_KEYS } from '../CreateGoalTrackerModal'

export enum FilterOptions {
  ApplyFilter = 'apply-filter',
  NoFilter = 'no-filter',
}

const GoalTrackerSelectFilterStep = () => {
  const { formatMessage } = useIntl()
  const { allowsNextWithoutData, setAllowsNextWithoutData } = useCreationModalProgress()
  const { watch, getValues, setValue, reset } = useFormContext()
  const { clearQueryFilter } = useFiltersContext()
  const [hasBeenReset, setHasBeenReset] = useState(false)
  const filters = useGetApiQueryFilters(CATEGORY_FILTER_DRAWER_ALLOWED_FILTERS)
  const filterCollectionsValue = watch(GOAL_TRACKER_QUESTION_KEYS.FILTER_COLLECTIONS)
  const [activeFilterOption, setActiveFilterOption] = useState<FilterOptions>(
    filterCollectionsValue?.length ? FilterOptions.ApplyFilter : FilterOptions.NoFilter,
  )

  useDeepCompareEffect(() => {
    setValue(GOAL_TRACKER_QUESTION_KEYS.FILTER_COLLECTIONS, filters)
  }, [filters])

  const currentValues = getValues()

  useDeepCompareEffect(() => {
    const shouldAllowNext = activeFilterOption === FilterOptions.NoFilter
    if (shouldAllowNext !== allowsNextWithoutData) {
      setAllowsNextWithoutData(shouldAllowNext)
    }

    if (shouldAllowNext && !hasBeenReset) {
      setHasBeenReset(true)
      reset({ ...currentValues, filterCollections: filters })
    }
  }, [filters, currentValues, activeFilterOption, hasBeenReset, allowsNextWithoutData])

  const handleFilterOptionChange = (
    event: React.ChangeEvent<{
      value: string
    }>,
  ): void => {
    if (event.target.value === FilterOptions.NoFilter) {
      clearQueryFilter()
      setAllowsNextWithoutData(true)
      reset({ ...currentValues, filterCollections: [] })
      setActiveFilterOption(FilterOptions.NoFilter)
    }
    if (event.target.value === FilterOptions.ApplyFilter) {
      setAllowsNextWithoutData(false)
      reset({ ...currentValues, filterCollections: filters })
      setActiveFilterOption(FilterOptions.ApplyFilter)
    }
  }

  return (
    <>
      <RadioGroup value={activeFilterOption} onChange={handleFilterOptionChange}>
        <FormControlLabel
          value={FilterOptions.NoFilter}
          control={<Radio />}
          label={formatMessage({ id: 'schemas.goalTracker.filter.noFilter' })}
        />
        <FormControlLabel
          value={FilterOptions.ApplyFilter}
          control={<Radio />}
          label={formatMessage({ id: 'schemas.goalTracker.filter.applyFilters' })}
        />
      </RadioGroup>
      <SelectFilterStep activeFilterOption={activeFilterOption} />
    </>
  )
}
export default GoalTrackerSelectFilterStep
